import { useContext, useEffect, useState } from 'react';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GlobalContext } from '../../App';

export default function Navigator(props) {
  const { token, userId, permission } = useContext(GlobalContext);

  const homePage = useSelector((state) => state.homePage.data);
  const categories = useSelector((state) => state.menu.categories);
  const theme = useTheme();
  const { ...other } = props;
  const [myCategories, setMyCategories] = useState(categories);

  useEffect(() => {
    const pathnameParts = window.location.pathname
      .split('/')
      .filter((part) => part.trim() !== '');
    const updatedCategories = myCategories.map((category) => {
      return {
        ...category,
        children: category.children.map((child) => {
          const isActive = child?.navigator === pathnameParts[0];
          if (isActive) {
            localStorage.setItem(
              'active_route',
              JSON.stringify(child?.navigator)
            );
          }
          return {
            ...child,
            active: isActive
          };
        })
      };
    });
    setMyCategories(updatedCategories);
  }, []);

  const handleItemClick = (clickedId) => {
    const updatedCategories = myCategories.map((category) => {
      return {
        ...category,
        children: category.children.map((child) => {
          const isActive = child.id === clickedId;
          isActive &&
            localStorage.setItem(
              'active_route',
              JSON.stringify(child?.navigator)
            );
          return { ...child, active: isActive };
        })
      };
    });

    setMyCategories(updatedCategories);
  };

  return (
    <Drawer variant="permanent" {...other}>
      <List>
        <ListItem style={theme?.CustomNavBarSide?.logoContainer}>
          <Box
            component="img"
            src="/logoMini.png"
            alt="App Logo"
            sx={theme?.CustomNavBarSide?.logo}
          />
        </ListItem>
        <NavLink
          to={`/${homePage.find(home => home.userId.includes(parseInt(userId)))?.navigator}`}
          style={{ textDecoration: 'none' }}>
          <ListItemButton
            sx={{
              ...theme?.CustomNavBarSide?.item,
              ...theme?.CustomNavBarSide?.itemCategory
            }}>
            <ListItemIcon>
              {/* מציג את האייקון שמגיע מה-Slice */}
              {homePage.find(home => home.userId.includes(parseInt(userId)))?.icon}
            </ListItemIcon>
            {/* מציג את שם דף הבית */}
            <ListItemText style={theme?.CustomNavBarSide?.listItemTextColor}>
              {homePage.find(home => home.userId.includes(parseInt(userId)))?.name}
            </ListItemText>
          </ListItemButton>
        </NavLink>

        {myCategories.map(({ id, permissions = [], children }) => (
                (permission === 0 || permissions?.includes(permission)) &&
          <Box
            key={id}
            sx={{
              ...theme?.CustomNavBarSide?.boxBgColor,
              ...theme?.CustomNavBarSide?.itemCategory
            }}>
            <NavLink to="#" style={theme?.CustomNavBarSide?.navLink}>
              <ListItemText
                style={theme?.CustomNavBarSide?.listItemCategoryTextColor}>
                {id}
              </ListItemText>
            </NavLink>
            {children.map(({ id: childId, icon, navigator, active }) => (
              <NavLink
                to={navigator}
                style={{
                  ...theme?.CustomNavBarSide?.navLink,
                  ...theme?.CustomNavBarSide?.typography
                }}
                key={childId}>
                <ListItemButton
                  onClick={() => handleItemClick(childId)}
                  selected={active}
                  sx={theme?.CustomNavBarSide?.item}>
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      sx: {
                        ...theme?.CustomNavBarSide?.listItemTextColor,
                        ...theme?.CustomNavBarSide?.typography
                      }
                    }}>
                    {childId}
                  </ListItemText>
                </ListItemButton>
              </NavLink>
            ))}
            <Divider sx={theme?.CustomNavBarSide?.divider} />
          </Box>
        ))}
      </List>
    </Drawer>
  );
}
